import { render, staticRenderFns } from "./ShowHeader.vue?vue&type=template&id=6b0a266a&"
import script from "./ShowHeader.vue?vue&type=script&lang=ts&"
export * from "./ShowHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ShowHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InlineVideo: require('/tmp/build_71ad00c4/src/components/media/InlineVideo.vue').default,AdaptiveImageNew: require('/tmp/build_71ad00c4/src/components/media/AdaptiveImageNew.vue').default,AnimateText: require('/tmp/build_71ad00c4/src/components/animate/AnimateText.vue').default,IconsPlay: require('/tmp/build_71ad00c4/src/components/icons/play.vue').default,ButtonCircle: require('/tmp/build_71ad00c4/src/components/button/Circle.vue').default,Button: require('/tmp/build_71ad00c4/src/components/button/Button.vue').default,ModalVideoPlayer: require('/tmp/build_71ad00c4/src/components/modal/VideoPlayer.vue').default})
